class Testimonials extends HTMLElement {
  constructor() {
    super()

    this.sliderInited = false
    this.layout = this.dataset.layout
    this.slidesPerView = this.layout === 'horizontal' ? 'auto' : 4
    this.initSlider()
  }

  initSlider() {
    this.sliderElement = new Swiper(this.querySelector(".js-slider"), {
      slidesPerView: 1,
      initialSlide: 0,
      spaceBetween: 30,
      autoHeight: true,
      slidesPerGroup: 1,
      breakpoints: {
        992: {
          slidesPerView: this.slidesPerView,
          spaceBetween: 22,
          autoHeight: false,
          slidesPerGroup: 2,
        },
      },
      navigation: {
        nextEl: ".testimonials-section__content--inner .button-next",
        prevEl: ".testimonials-section__content--inner .button-prev",
      },
      pagination: {
        el: ".js-swiper-pagination",
        clickable: true,
      },
    })
    this.sliderInited = true
  }

  get breakpoint() {
    return this.getAttribute("data-breakpoint") || ""
  }
}

customElements.define("testimonials-carousel", Testimonials)
